import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import { getDaysBeforeClosing, toMoment } from '@/util/date-util';

class InviteService {
  validateInvite(token) {
    return ApiService.get(`${Config.api.auth.url}invites/${token}/validate`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }
  acceptInvite({ token, user }) {
    return ApiService.post(`${Config.api.auth.url}invites/${token}/accept`, user)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }
  confirmEmail(token) {
    return ApiService.put(`${Config.api.auth.url}auth/confirm-email?token=${token}`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }
  resendEmail(token) {
    return ApiService.put(`${Config.api.auth.url}auth/resend-email?token=${token}`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }
  resendEmailFromLogin(email) {
    return ApiService.put(`${Config.api.auth.url}auth/resend-email?email=${email}`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }
  mapError(error) {
    if (error.response.data) {
      return error.response.data;
    } else if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }

  // ----- Admin -----
  getInvitesByTenant(tenantId) {
    return ApiService.get(`${Config.api.auth.url}tenants/${tenantId}/invites`)
      .then((response) => {
        return mapToInvite(response.data);
      })
      .catch((error) => {
        throw this.mapError(error);
      });
  }
  sendInvite(tenantId, email, locale, role) {
    return ApiService.post(`${Config.api.auth.url}invites`, { tenantId, email, locale, role })
      .then((response) => response.data)
      .catch((error) => {
        const status = error.response && error.response.status;
        throw { status, data: this.mapError(error) };
      });
  }
  resendInvite(inviteId) {
    return ApiService.post(`${Config.api.auth.url}invites/${inviteId}/resend`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }
  revokeInvite(inviteId) {
    return ApiService.put(`${Config.api.auth.url}invites/${inviteId}/revoke`)
      .then((response) => response.data)
      .catch((error) => {
        throw this.mapError(error);
      });
  }
}

const mapToInvite = (results = []) =>
  results.map((i) => ({
    id: i.id,
    tenantId: i.tenantId,
    from: i.from,
    locale: i.locale,
    role: i.role,
    state: i.state,
    email: i.email,
    createdAt: i.createdAt ? toMoment(i.createdAt) : '-',
    expiresAt: toMoment(i.expiresAt),
    updatedAt: i.updatedAt ? toMoment(i.updatedAt) : '-',
    daysBeforeExpire: getDaysBeforeClosing(i.expiresAt),
  }));

export const inviteService = new InviteService();
